import { z } from 'zod';
import { optionalNullableDateInput, requiredUuidString } from '../zod-helpers/index.js';
import { MAX_SHIP_LINE_ITEMS_PER_REQUEST } from './ship-input.js';
/** Soft cap so a malformed client cannot flood carton rows in one mutation. */
export const MAX_SHIP_CARTONS_PER_RECORD = 50;
export const purchaseOrderShipCartonInputSchema = z.object({
    trackingNum: z.string().trim().max(512).nullish(),
    freightAmount: z.number().finite().nullish(),
    freightWeight: z.number().finite().nullish(),
    height: z.number().finite().nullish(),
    len: z.number().finite().nullish(),
    width: z.number().finite().nullish(),
    sizeUom: z.string().trim().max(30).nullish(),
    weightUom: z.string().trim().max(32).nullish(),
    insuredValue: z.number().finite().nullish(),
    additionalHandling: z.boolean().optional(),
    shipperRelease: z.boolean().optional(),
    sscc: z.string().trim().max(20).nullish(),
    carrierId: z.uuid({ version: 'v7' }).nullish(),
});
export const recordPurchaseOrderShipmentInputSchema = z.object({
    lineItemIds: z
        .array(requiredUuidString('Line item is required.', 'Invalid line item selection.'))
        .min(1, 'At least one line item is required.')
        .max(MAX_SHIP_LINE_ITEMS_PER_REQUEST, 'Too many line items in a single request.')
        .refine((ids) => new Set(ids).size === ids.length, 'Duplicate line item IDs are not allowed.'),
    carrierId: requiredUuidString('Carrier is required.', 'Invalid carrier selection.'),
    carrierServiceId: z.uuid({ version: 'v7' }).nullish(),
    billOfLading: z.string().trim().max(20).nullish(),
    note: z.string().max(2000).nullish(),
    dateShipped: optionalNullableDateInput,
    dateEstimatedDelivery: optionalNullableDateInput,
    cartons: z
        .array(purchaseOrderShipCartonInputSchema)
        .max(MAX_SHIP_CARTONS_PER_RECORD, `At most ${MAX_SHIP_CARTONS_PER_RECORD} cartons per shipment.`)
        .nullish(),
});
//# sourceMappingURL=record-shipment-input.js.map